import { AuthenticationType, data } from 'azure-maps-control';
import { AzureMap } from 'react-azure-maps';
import { boundingBoxNetherlands } from './constants';

import type { IAzureMapOptions } from 'react-azure-maps';

const option: IAzureMapOptions = {
  center: data.BoundingBox.getCenter(boundingBoxNetherlands),
  view: 'Auto',
  authOptions: {
    authType: AuthenticationType.subscriptionKey,
    subscriptionKey: 'uWUJ5J_clGOTx6KRUG3GNw-VK3FUDHhDIivRl1D4NKE'
  },
  showLogo: false,
  showFeedbackLink: false
};

export default function MapComponent() {
  return (
    <div style={styles.map}>
      <AzureMap options={option} />
    </div>
  );
}

const styles = {
  map: {
    height: '100%'
  }
};
